module.exports = __webpack_public_path__ + "img/logo.f797dc07.jpg";